<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <div class="card mb-4">
          <div class="card-header pb-0">
            <h4>Trattamenti Periodici</h4>
            <button type="button" id="add-btn" class="btn btn-primary" @click="clear" data-bs-toggle="modal" data-bs-target="#formModal">+ Nuovo</button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <custom-table ref="table$" :rows="data" @action="runAction" :columns="[
                {
                    title: 'Trattamento',
                    type: 'text',
                    data: 'treatment.type',
                },
                {
                    title: 'Data',
                    type: 'date',
                    data: 'date',
                },
                {
                    title: 'Scadenza',
                    type: 'date',
                    data: 'expiration',
                },
                {
                    title: 'Note',
                    type: 'text',
                    data: 'note',
                },
                {
                    title: 'Fatto',
                    type: 'boolean',
                    data: 'done',
                    on_label: 'SI',
                    off_label: 'NO'
                },
            ]" :actions="[
                {
                    title: 'Modifica',
                    tooltip: 'edit',
                    key: 'edit',
                },
            ]" 
              :pagination="pagination"
              @page-changed="handlePageChange"
              @update-pagination="handlePaginationUpdate"
              @search-changed="handleSearchChange"
            />
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="formModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="add" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="formModalBtn">Trattamento</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="color: black;"></button>
        </div>
        <div class="modal-body">
          <Vueform ref="form$" v-model="horse_treatment" sync>
            <HiddenElement name="id" />
            <SelectElement
                name="treatment_id"
                :native="false"
                label="Trattamento"
                rules="required"
                :items="treatments"
            />
            <DateElement name="date" label="Data" rules="required"></DateElement>
            <DateElement name="expiration" label="Scadenza" rules="required"></DateElement>
            <TextareaElement name="note" label="Note" rules=""></TextareaElement>
            <ToggleElement name="done">
              Fatto
            </ToggleElement>
            <hr/>
            <MultifileElement
              name="horse_treatment_images"
              :object="true"
              url="https://equiup-api.13bit.dev/api/horse-images/get-photo"
              preview-url="https://equiup-api.13bit.dev/api/horse-images/get-thumbnail"
              :upload-temp-endpoint="false"
              label="Upload Foto"
              view="gallery"
              :clickable="true"
              :drop="true"
              storeFile="url"
              :soft-remove="true"
            />
          </Vueform>

        </div>
        <div class="modal-footer">
          <button type="button" id="close" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
          <button type="button" class="btn btn-primary" :class="{ loading: loading }"  @click="save">Salva</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import {horsesTreatmentService} from "@/services/HorsesTreatmentService";
import CustomTable from "@/components/CustomTable";
import { useToast } from "vue-toastification";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useTableData } from "../../composables/useTableData";
const toast = useToast();

export default {
  name: "HorseTreatments",
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      horse_treatment: {},
      treatments: [],
    };
  },
  setup(){
    return useTableData(
        horsesTreatmentService.getHorseTreatments.bind(horsesTreatmentService),
        10
    );
  },
  created() {
    this.$store.dispatch('updateBreadcrumbs', [
      { title: 'Lista Cavalli', name: 'Horses' },
      { title: 'Cavallo', name: 'Horse', params: { id: this.id } },
      { title: 'Salute', name: 'HorseHealth', params: { id: this.id } },
    ]);
  },
  mounted(){
    this.fetchData({horse_id: this.id});
    horsesTreatmentService.getTreatments().then(treatments => this.treatments = treatments.map(t => ({value: t.id, label: t.type})));
  },
  computed: {
  },
  components: {
    CustomTable
  },
  methods: {
    async runAction({action, row}){
      this.loading = true;
      if(action.key == 'edit'){
        horsesTreatmentService.getHorseTreatmentById(row.id).then((treatment) => {
          this.horse_treatment = treatment;
          this.loading=false;
          const modalElement = document.getElementById('formModal');
          const myModal = new bootstrap.Modal(modalElement);
          myModal.show();
        });
      }
    },
    clear(){
      this.horse_treatment = {};
      this.$refs.form$.reset();
    },
    async save(){
      const form = this.$refs.form$;
      form.validate();
      if(this.horse_treatment.id) form.data.id = this.horse_treatment.id;
      form.data.horse_id = this.id;

      if(form.data.done) form.data.done = 1;
      else form.data.done = 0;

      if (!form.hasErrors) {
        for (const key in form.data) {
          if (form.data[key] === 'null' || form.data[key] === null) {
              delete form.data[key];
          }
        }
        this.loading=true;
        try{
          await horsesTreatmentService.saveHorseTreatment(form.data);
          toast(this.$t('operation_saved'));
          document.getElementById('close').click();
          this.fetchData({horse_id: this.id});
        }finally{
          this.loading=false;
        }
      }
    },
  },
};
</script>
